import type { VideoEntity } from "../api/videoService";

/**
 * T2A 上传图实体的确认单纯逻辑(Track 2 Phase 2A):
 * 分类会错 → 确认单展示「产品=图X」映射并可纠(不做黑箱,呼应「接口喂的值永远是死的」)。
 */

/** 低于此置信度(或 role=other)→ 待人工确认,确认单高亮。与 ai 侧 _UNCERTAIN_BELOW 对齐。 */
export const UNCERTAIN_BELOW = 0.6;

/**
 * 图背书产品实体的第一张 key → productRefKey(单产品便捷位)。ai 模式路由器用它当产品 hero 镜的
 * i2i 种子;只认 source=image 且带 key 的 product(文本背书 product 无图,不能当 i2i 种子)。
 */
export function deriveProductRefKey(entities: VideoEntity[] | null | undefined): string {
  const p = (entities ?? []).find((e) => e.source === "image" && e.role === "product" && !!e.key);
  return p?.key ?? "";
}

/** 该实体是否待人工确认(role=other 没判出来 / 置信度低)。 */
export function isUncertain(e: VideoEntity): boolean {
  return e.role === "other" || (e.confidence ?? 1) < UNCERTAIN_BELOW;
}

/**
 * 确认单编辑:改某实体的 role(用户纠分类)。改成非 product 时清掉 productId —— 否则留一个
 * 指向已不是产品的旧映射(死数据)。返新数组不改入参。
 */
export function setEntityRole(
  entities: VideoEntity[],
  id: string,
  role: VideoEntity["role"],
): VideoEntity[] {
  return entities.map((e) =>
    e.id === id ? { ...e, role, productId: role === "product" ? e.productId : "" } : e,
  );
}
